(function(){
'use strict';

var PX_PER_MM = 12;

var SIZES = {
  oval: [
    {w:27,h:37},{w:23,h:31},{w:19,h:28},{w:16,h:23},{w:16,h:21},{w:14,h:18},{w:11,h:15}
  ],
  heart: [
    {w:29,h:28},{w:20,h:20},{w:18,h:17},{w:15,h:14},{w:11,h:10}
  ],
  rectangle: [
    {w:14.9,h:21.4}
  ],
  circle: [
    {w:22,h:22}
  ]
};

var PAPERS = {
  '10x15': {w:150,h:100},
  '9x13':  {w:130,h:90}
};

var S = {
  paper: '10x15',
  shape: 'oval',
  sizeIdx: 3,
  img1: null, img2: null,
  offset1: {x:0,y:0}, offset2: {x:0,y:0},
  zoom1: 1, zoom2: 1,
  rot1: 0, rot2: 0,
  guides: true
};

var canvas = document.getElementById('preview');
var ctx = canvas.getContext('2d');

function mmToPx(mm){ return mm * PX_PER_MM; }

function renderSizes(){
  var seg = document.getElementById('sizeSeg');
  seg.innerHTML = '';
  var sizes = SIZES[S.shape];
  for(var i=0;i<sizes.length;i++){
    var opt = document.createElement('option');
    opt.value = i;
    opt.textContent = sizes[i].w + ' \xD7 ' + sizes[i].h + ' mm';
    if(i===S.sizeIdx) opt.selected = true;
    seg.appendChild(opt);
  }
}

function setupSeg(id, key, cb){
  var buttons = document.querySelectorAll('#'+id+' button');
  for(var i=0;i<buttons.length;i++){
    (function(b){
      b.onclick = function(){
        var all = document.querySelectorAll('#'+id+' button');
        for(var j=0;j<all.length;j++) all[j].classList.remove('active');
        b.classList.add('active');
        S[key] = b.dataset[key];
        if(cb) cb();
        draw();
      };
    })(buttons[i]);
  }
}

setupSeg('paperSeg','paper',null);
setupSeg('shapeSeg','shape',function(){
  S.sizeIdx = Math.min(S.sizeIdx, SIZES[S.shape].length-1);
  renderSizes();
});
renderSizes();
document.getElementById('sizeSeg').addEventListener('change',function(){
  S.sizeIdx = parseInt(this.value);
  draw();
});

function loadFile(input, slot){
  input.addEventListener('change',function(e){
    var f = e.target.files[0];
    if(!f) return;
    document.getElementById('name'+slot).textContent = f.name;
    var img = new Image();
    img.onload = function(){
      S['img'+slot] = img;
      S['offset'+slot] = {x:0,y:0};
      document.getElementById('ctrl'+slot).style.display = 'block';
      draw();
    };
    img.src = URL.createObjectURL(f);
  });
}
loadFile(document.getElementById('file1'),1);
loadFile(document.getElementById('file2'),2);

var sliders = ['zoom1','zoom2','rot1','rot2'];
for(var si=0;si<sliders.length;si++){
  (function(id){
    document.getElementById(id).addEventListener('input',function(e){
      if(id.indexOf('zoom')===0) S[id] = e.target.value/100;
      else S[id] = parseInt(e.target.value);
      draw();
    });
  })(sliders[si]);
}

document.getElementById('guides').addEventListener('change',function(e){
  S.guides = e.target.checked; draw();
});

document.getElementById('resetBtn').onclick = function(){
  S.offset1={x:0,y:0}; S.offset2={x:0,y:0};
  S.zoom1=S.zoom2=1; S.rot1=S.rot2=0;
  document.getElementById('zoom1').value=100;
  document.getElementById('zoom2').value=100;
  document.getElementById('rot1').value=0;
  document.getElementById('rot2').value=0;
  draw();
};

function shapePath(c,shape,w,h){
  c.beginPath();
  if(shape==='oval'||shape==='circle'){
    c.ellipse(0,0,w/2,h/2,0,0,Math.PI*2);
  } else if(shape==='rectangle'){
    var r=Math.min(w,h)*0.15, x=-w/2, y=-h/2;
    if(c.roundRect){
      c.roundRect(x,y,w,h,r);
    } else {
      c.moveTo(x+r,y); c.lineTo(x+w-r,y);
      c.arcTo(x+w,y,x+w,y+r,r); c.lineTo(x+w,y+h-r);
      c.arcTo(x+w,y+h,x+w-r,y+h,r); c.lineTo(x+r,y+h);
      c.arcTo(x,y+h,x,y+h-r,r); c.lineTo(x,y+r);
      c.arcTo(x,y,x+r,y,r); c.closePath();
    }
  } else {
    c.moveTo(0,-h*0.37);
    c.bezierCurveTo(w*0.10,-h*0.56,w*0.50,-h*0.50,w*0.50,-h*0.12);
    c.bezierCurveTo(w*0.50,h*0.22,w*0.08,h*0.44,0,h*0.50);
    c.bezierCurveTo(-w*0.08,h*0.44,-w*0.50,h*0.22,-w*0.50,-h*0.12);
    c.bezierCurveTo(-w*0.50,-h*0.50,-w*0.10,-h*0.56,0,-h*0.37);
    c.closePath();
  }
}

function drawSlot(cx,cy,slot){
  var size=SIZES[S.shape][S.sizeIdx];
  var w=mmToPx(size.w), h=mmToPx(size.h);
  var img=S['img'+slot], off=S['offset'+slot];
  var zoom=S['zoom'+slot], rot=S['rot'+slot]*Math.PI/180;
  ctx.save();
  ctx.translate(cx,cy);
  ctx.save();
  shapePath(ctx,S.shape,w,h);
  ctx.clip();
  ctx.fillStyle='#f5f0e8';
  ctx.fillRect(-w/2,-h/2,w,h);
  if(img){
    var iw=img.naturalWidth, ih=img.naturalHeight;
    var scale=Math.max(w/iw,h/ih)*zoom;
    ctx.translate(off.x,off.y);
    ctx.rotate(rot);
    ctx.drawImage(img,-iw*scale/2,-ih*scale/2,iw*scale,ih*scale);
  } else {
    ctx.fillStyle='#b8a890';
    ctx.font=mmToPx(2)+'px sans-serif';
    ctx.textAlign='center';
    ctx.textBaseline='middle';
    ctx.fillText('Bild '+slot,0,0);
  }
  ctx.restore();
  if(S.guides){
    shapePath(ctx,S.shape,w,h);
    ctx.strokeStyle='#888';
    ctx.lineWidth=Math.max(1,mmToPx(0.15));
    ctx.setLineDash([mmToPx(1),mmToPx(1)]);
    ctx.stroke();
    ctx.setLineDash([]);
  }
  ctx.restore();
}

function draw(){
  var paper=PAPERS[S.paper];
  var W=Math.round(mmToPx(paper.w)), H=Math.round(mmToPx(paper.h));
  canvas.width=W; canvas.height=H;
  var dispScale=Math.min(640/W,1);
  canvas.style.width=(W*dispScale)+'px';
  canvas.style.height='auto';
  ctx.fillStyle='#ffffff';
  ctx.fillRect(0,0,W,H);
  var size=SIZES[S.shape][S.sizeIdx];
  var sw=mmToPx(size.w), gap=mmToPx(8);
  var totalW=sw*2+gap;
  var startX=(W-totalW)/2+sw/2;
  var cy=H/2;
  drawSlot(startX,cy,1);
  drawSlot(startX+sw+gap,cy,2);
}

var dragging=null, dragMoved=false;

canvas.addEventListener('mousedown',function(e){
  var rect=canvas.getBoundingClientRect();
  var scaleX=canvas.width/rect.width;
  var x=(e.clientX-rect.left)*scaleX;
  var slot=x<canvas.width/2?1:2;
  dragMoved=false;
  dragging={slot:slot,startX:e.clientX,startY:e.clientY,
    origX:S['offset'+slot].x,origY:S['offset'+slot].y,scale:scaleX};
});
window.addEventListener('mousemove',function(e){
  if(!dragging) return;
  var dx=e.clientX-dragging.startX;
  var dy=e.clientY-dragging.startY;
  if(Math.abs(dx)>3||Math.abs(dy)>3) dragMoved=true;
  S['offset'+dragging.slot]={x:dragging.origX+dx*dragging.scale,y:dragging.origY+dy*dragging.scale};
  draw();
});
window.addEventListener('mouseup',function(){ dragging=null; });

canvas.addEventListener('click',function(e){
  if(!dragMoved){
    var rect=canvas.getBoundingClientRect();
    var x=(e.clientX-rect.left)*(canvas.width/rect.width);
    document.getElementById(x<canvas.width/2?'file1':'file2').click();
  }
  dragMoved=false;
});

canvas.addEventListener('touchstart',function(e){
  if(e.touches.length!==1) return;
  var t=e.touches[0];
  var rect=canvas.getBoundingClientRect();
  var scaleX=canvas.width/rect.width;
  var x=(t.clientX-rect.left)*scaleX;
  var slot=x<canvas.width/2?1:2;
  dragMoved=false;
  dragging={slot:slot,startX:t.clientX,startY:t.clientY,
    origX:S['offset'+slot].x,origY:S['offset'+slot].y,scale:scaleX};
},{passive:true});
canvas.addEventListener('touchmove',function(e){
  if(!dragging||e.touches.length!==1) return;
  var t=e.touches[0];
  var dx=t.clientX-dragging.startX;
  var dy=t.clientY-dragging.startY;
  if(Math.abs(dx)>3||Math.abs(dy)>3) dragMoved=true;
  S['offset'+dragging.slot]={x:dragging.origX+dx*dragging.scale,y:dragging.origY+dy*dragging.scale};
  draw();
  e.preventDefault();
},{passive:false});
canvas.addEventListener('touchend',function(e){
  if(!dragMoved&&e.changedTouches.length===1){
    var t=e.changedTouches[0];
    var rect=canvas.getBoundingClientRect();
    var x=(t.clientX-rect.left)*(canvas.width/rect.width);
    document.getElementById(x<canvas.width/2?'file1':'file2').click();
  }
  dragging=null; dragMoved=false;
});

function jpegWith300DPI(c){
  var raw=c.toDataURL('image/jpeg',0.95);
  var b64=raw.split(',')[1];
  var binary=atob(b64);
  var bytes=new Uint8Array(binary.length);
  for(var i=0;i<binary.length;i++) bytes[i]=binary.charCodeAt(i);
  if(bytes[0]===0xFF&&bytes[1]===0xD8&&bytes[2]===0xFF&&bytes[3]===0xE0){
    var dpi=300;
    bytes[13]=1;
    bytes[14]=(dpi>>8)&0xFF; bytes[15]=dpi&0xFF;
    bytes[16]=(dpi>>8)&0xFF; bytes[17]=dpi&0xFF;
  }
  return URL.createObjectURL(new Blob([bytes],{type:'image/jpeg'}));
}

document.getElementById('downloadBtn').onclick=function(){
  var wasGuides=S.guides;
  S.guides=false; draw();
  var url=jpegWith300DPI(canvas);
  var size=SIZES[S.shape][S.sizeIdx];
  var link=document.createElement('a');
  link.download='aurevia-medaillon-'+S.paper+'-'+S.shape+'-'+size.w+'x'+size.h+'mm.jpg';
  link.href=url;
  link.click();
  setTimeout(function(){ URL.revokeObjectURL(url); },2000);
  S.guides=wasGuides; draw();
};

document.getElementById('printBtn').onclick=function(){
  var wasGuides=S.guides;
  S.guides=false; draw();
  var imgData=canvas.toDataURL('image/jpeg',0.97);
  S.guides=wasGuides; draw();
  var paper=PAPERS[S.paper];
  var pw=paper.w+'mm', ph=paper.h+'mm';
  var win=window.open('','_blank');
  win.document.write('<!DOCTYPE html><html><head><style>'
    +'@page{size:'+pw+' '+ph+';margin:0}'
    +'*{margin:0;padding:0;box-sizing:border-box}'
    +'body{width:'+pw+';height:'+ph+';overflow:hidden}'
    +'img{width:'+pw+';height:'+ph+';display:block;object-fit:fill}'
    +'</style></head><body>'
    +'<img src="'+imgData+'">'
    +'</body></html>');
  win.document.close();
  win.onload=function(){ win.print(); };
};

draw();
})();